import { App } from 'vue';
import CallToAction from './call-to-action/CallToAction.vue';

export default function config(app: App<Element>): void {
    app.component(CallToAction.name, CallToAction);
}
